import bus from '../libs/bus';
import AnalyticsPublic from './AnalyticsPublic';
import BaseLib from './BaseLib';

export default {
  name: 'StateHandler',

  store: null,

  loadFromOuter(paramObj) {
    this.store = paramObj;
  },

  updateBusData() {
    bus.productid = parseInt(AnalyticsPublic.productid);
    bus.platform = AnalyticsPublic.platform;
    bus.selectedDate = AnalyticsPublic.selectedDate;
    bus.conditions.partner = AnalyticsPublic.conditions.partner || [];
    bus.conditions.version = AnalyticsPublic.conditions.version || [];
    bus.conditions.newUserGroup = AnalyticsPublic.conditions.newUserGroup || [];
  },

  loadPublic() {
    const pubStr = localStorage.getItem('_analytics_public');
    if (pubStr !== null) {
      const tmpObj = JSON.parse(pubStr) || {};
      if (!tmpObj.conditions) {
        tmpObj.conditions = {};
      }
      if (!tmpObj.conditions.partner) {
        tmpObj.conditions.partner = [];
      }
      if (!tmpObj.conditions.version) {
        tmpObj.conditions.version = [];
      }
      if (!tmpObj.conditions.usergroup) {
        tmpObj.conditions.usergroup = [];
      }
      if (!tmpObj.conditions.newUserGroup) {
        tmpObj.conditions.newUserGroup = [];
      }
      if (tmpObj.selectedDate.length === 0) {
        tmpObj.selectedDate = [BaseLib.getDay(-30), BaseLib.getDay(0)];
      }
      Object.assign(AnalyticsPublic, tmpObj);
      this.store.commit('setTransFilterObj', tmpObj);
      this.updateBusData();
    } else {
      AnalyticsPublic.selectedDate = [BaseLib.getDay(-30), BaseLib.getDay(0)];
      this.savePublic();
    }
  },
  savePublic(tmpObj) {
    if (tmpObj) {
      this.store.commit('setTransFilterObj', tmpObj);
    }
    const transObjTmp = BaseLib.cloneDeep(this.store.state.transFilterObj);
    Object.assign(AnalyticsPublic, transObjTmp);
  },
};